// extracted by mini-css-extract-plugin
export var list = "style-module--list--13213";
export var loadingContainer = "style-module--loadingContainer--ee3d5";
export var noResult = "style-module--noResult--34b56";
export var query = "style-module--query--3bfd0";
export var text = "style-module--text--80f1d";